export const AUTH_MODE_KEYCLOAK = 'keycloak';
export const AUTH_MODE_PARENT = 'parent';

/**
 * Resolve the frontend authentication mode without allowing a production URL
 * or a stale tenant env file to turn authentication off.
 *
 * Production rules are deliberately fail-closed:
 *   - direct/standalone access always uses Keycloak;
 *   - the explicit ?auth=parent bridge is allowed for trusted dashboard embeds;
 *   - browser API-key mode does not exist, including during local development.
 */
export function resolveAuthMode({
  search = '',
  configuredMode = AUTH_MODE_KEYCLOAK,
  nodeEnv = 'production',
  hostname = '',
} = {}) {
  const requestedMode = new URLSearchParams(search).get('auth');

  // Athena Core and Ageleia embeds explicitly request the parent bridge.
  if (requestedMode === AUTH_MODE_PARENT) return AUTH_MODE_PARENT;

  // Unknown modes, ?auth=apikey, and apikey/parent config all fail
  // closed to SSO. A deployment mistake must never produce a public no-login UI.
  return AUTH_MODE_KEYCLOAK;
}
